

// ==========================================
// ParticipantModal.jsx
// ==========================================
const ParticipantModal = ({ 
  isOpen, 
  participant, 
  onClose, 
  calculateTotal, 
  getCurrentChallengeDay, 
  openLightbox 
}) => {
  if (!isOpen || !participant) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{participant.participantName}</h3>
          <button className="close-modal" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="days-grid">
            {[...Array(25)].map((_, i) => {
              const dayKey = `day${i + 1}`;
              const dayData = participant.days[dayKey];
              const currentDay = getCurrentChallengeDay();
              const isFutureDay = (i + 1) > currentDay;
              const isCurrentDay = (i + 1) === currentDay;
              
              return (
                <div 
                  key={i} 
                  className={`day-cell ${isFutureDay ? 'future-day' : ''} ${isCurrentDay ? 'current-day' : ''}`}
                >
                  <div className="day-number">{i + 1}</div>
                  {dayData ? (
                    <div className="day-content">
                      {dayData.image_url ? (
                        <div
                          onClick={() => openLightbox(participant, i + 1)}
                          className="day-value clickable"
                        >
                          {Math.round(dayData.body * 10) / 10}
                        </div>
                      ) : (
                        <div className="day-value">{Math.round(dayData.body * 10) / 10}</div>
                      )}
                    </div>
                  ) : (
                    <div className="day-content empty">-</div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="modal-footer">
            <div>Total Runs: {participant.totalRuns}</div>
            <div>Total Miles: {calculateTotal(participant.days)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipantModal;